import { BrowserRouter, Route ,Routes } from 'react-router-dom'; // React Router setup
import Home from './Pages/Home';
import Consultancy from './Pages/Consultancy';
import Research from './Pages/Research';
import YearlyResearch from './Pages/YearlyResearch';

function App() {
  return (
    <div className="App">
      {/* <Nav/> */}

      <BrowserRouter basename={'/cv'}>
      {/* <BrowserRouter > */}
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/Research' element={<Research/>}/>
          <Route path='/consultancy' element={<Consultancy/>}/>
          <Route path='/research/:year' element={<YearlyResearch/>}/>
        </Routes>
    </BrowserRouter>
      
      
      
      
      {/* <Footer/> */}
    </div>
  );
}

export default App;


   
    